import { AaSigninReq } from 'app/bff/models/aa/aaSignin';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ProcessStepCodesEnum } from 'app/features/Member/Settings/PassPhrase/types';

// State type
export interface PassPhraseState {
  process: ProcessState;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
}
// ::: End

// Actions type constant
export const MEMBER_SETTINGS_PASS_PHRASE__SET_ACCESSIBLE_STEP = 'MEMBER_SETTINGS_PASS_PHRASE__SET_ACCESSIBLE_STEP';
export const MEMBER_SETTINGS_PASS_PHRASE__AUTH_PASS_PHRASE = 'MEMBER_SETTINGS_PASS_PHRASE__AUTH_PASS_PHRASE';
export const MEMBER_SETTINGS_PASS_PHRASE__SETUP_PASS_PHRASE = 'MEMBER_SETTINGS_PASS_PHRASE__SETUP_PASS_PHRASE';
export const MEMBER_SETTINGS_PASS_PHRASE__RESET_CACHE = 'MEMBER_SETTINGS_PASS_PHRASE__RESET_CACHE';
// ::: End

// Action creators type
export interface SetAccessibleStepAction {
  type: typeof MEMBER_SETTINGS_PASS_PHRASE__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface AuthPassPhraseAction {
  type: typeof MEMBER_SETTINGS_PASS_PHRASE__AUTH_PASS_PHRASE;
  payload: {
    args: AaSigninReq;
  };
}

export interface SetupPassPhraseAction {
  type: typeof MEMBER_SETTINGS_PASS_PHRASE__SETUP_PASS_PHRASE;
  payload: {
    args: MbUpdateinfoReq;
  };
}

export interface ResetCacheAction {
  type: typeof MEMBER_SETTINGS_PASS_PHRASE__RESET_CACHE;
}

export type PassPhraseActions =
    SetAccessibleStepAction
  | AuthPassPhraseAction
  | SetupPassPhraseAction
  | ResetCacheAction;
// ::: End
